/* eslint-disable no-console */
import { main, registerLegacySalvoLiteComponent } from '@eastsideco/salvo-ts';

class HandleShippingBanner {
    // handles layout shift when globale shipping banner is active
    constructor(theme, elem) {
        this._theme = theme;
        this._elem = elem;
        this._bannerElem = elem.querySelector('#GlobaleFreeShippingBannerContainerId');
    }

    onInit() {
        this.runObserver();
    }

    handleChanges(observer) {
        const mainElem = document.querySelector('.main');
        mainElem.classList.add('extra-margin');
        observer.disconnect();
    }

    runObserver() {
        const observer = new MutationObserver((mutationsList) => {
            this.handleChanges(observer);
        });

        const config = {
            childList: true,
            subtree: true
        };

        observer.observe(this._bannerElem, config);

    }
}

export default registerLegacySalvoLiteComponent({
    component: HandleShippingBanner,
    selector: '[data-handle-shipping-banner]', // Required
});
